import React, { Component } from 'react';
import { goto } from '../../../../actions/historyActions';
import { getLanguage } from '../../../../selectors/userSelectors';
import { resolvePublicAssets } from '../../../../utils';
import { SLIDER_ITEM_WIDTH } from '../../constants/constants';
import './style.scss';

interface CustomerProfileToolProps {
  id: string;
  icon: string;
  label: { [key: string]: string };
  deepLink?: {
    query: {
      url?: string;
    };
  };
  isActive: boolean;
  isShowSlider: boolean;
}

interface CustomerProfileToolState {
  isShowActiveIcon: boolean;
}

class CustomerProfileTool extends Component<
  CustomerProfileToolProps,
  CustomerProfileToolState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isShowActiveIcon: false,
    };
  }

  componentDidMount() {}

  onMouse = (isShowActiveIcon: boolean) => {
    this.setState({
      isShowActiveIcon,
    });
  };

  onGoTo = () => {
    // const { deepLink } = this.props;
    // if (deepLink && deepLink.query && deepLink.query.url) {
    //   goto(deepLink.query.url)
    // }
    // return;
  };

  render() {
    const { id, label, icon, isActive, deepLink, isShowSlider } = this.props;
    const { isShowActiveIcon } = this.state;
    const defaultIcon = resolvePublicAssets(
      `assets/${icon
        .replace('images/', 'images/customer-profile/')
        .replace('.png', '@3x.png')}`,
    );
    const toolDesc = label[getLanguage()];
    return (
      <div
        style={{ width: `${isShowSlider ? '' : SLIDER_ITEM_WIDTH}px` }}
        className={`customer-profile-tool ${
          isShowActiveIcon || isActive ? 'customer-profile-active-tool' : ''
        }`}
        onMouseMove={() => this.onMouse(true)}
        onMouseOut={() => this.onMouse(false)}
        onClick={() => this.onGoTo()}
      >
        <div className="customer-profile-tool__title">{toolDesc}</div>
        <div className="customer-profile-tool__img">
          <img src={defaultIcon} alt="" />
        </div>
      </div>
    );
  }
}

export default CustomerProfileTool;
